import { useState, useEffect } from "react";
import { apiFetch } from "../services/api.js";
import { getUser } from "../services/auth.js";

export default function CuponsCliente({ clienteId, onClose }) {
  const [cupons, setCupons] = useState([]);
  const [campanhas, setCampanhas] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState("");

  async function carregarDados() {
    setCarregando(true);
    try {
      const [cuponsRes, campanhasRes] = await Promise.all([
        apiFetch(`cupons/cliente/${clienteId}`),
        apiFetch("campanhas"),
      ]);
      setCupons(cuponsRes?.cupons || []);
      // Filtrar campanhas ativas e não arquivadas
      const campanhasAtivas = (campanhasRes?.campanhas || []).filter(
        (c) => c.ativo !== false && c.arquivado !== true,
      );
      setCampanhas(campanhasAtivas);
    } catch (err) {
      setErro(err.message || "Erro ao carregar cupons");
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => {
    if (clienteId) carregarDados();
  }, [clienteId]);

  if (carregando) return <p>Carregando cupons...</p>;

  const cuponsArray = Array.isArray(cupons) ? cupons : [];
  const cuponsAgrupados = cuponsArray.reduce((acc, cupom) => {
    const campanha = campanhas.find((c) => c.id === cupom.campanha_id);
    const nomeUnique = campanha?.nome || cupom.campanha_id;
    if (!acc[nomeUnique]) {
      acc[nomeUnique] = [];
    }
    acc[nomeUnique].push(cupom);
    return acc;
  }, {});

  async function handleEditar(cupom) {
    if (
      !window.confirm(
        "Deseja deletar este cupom? (Será necessário criar um novo)",
      )
    )
      return;
    try {
      await apiFetch(`cupons/${cupom.id}`, { method: "DELETE" });
      carregarDados();
    } catch (err) {
      setErro(err.message || "Erro ao deletar cupom");
    }
  }

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "white",
          padding: "2rem",
          borderRadius: "8px",
          maxWidth: "600px",
          width: "90%",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <h3>Cupons do Cliente</h3>
          <button
            onClick={onClose}
            style={{
              cursor: "pointer",
              fontSize: "1.5rem",
              border: "none",
              background: "none",
            }}
          >
            ✕
          </button>
        </div>

        {erro && <p style={{ color: "#e74c3c" }}>{erro}</p>}

        {Object.keys(cuponsAgrupados).length === 0 ? (
          <p>Nenhum cupom encontrado</p>
        ) : (
          Object.entries(cuponsAgrupados).map(([campanha, cuponsLista]) => (
            <div
              key={campanha}
              style={{
                marginBottom: "1.5rem",
                borderBottom: "1px solid #ddd",
                paddingBottom: "1rem",
              }}
            >
              <h4>{campanha}</h4>
              <p style={{ fontSize: "0.9rem", color: "#666" }}>
                {cuponsLista.length} cupom(ns)
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
                {cuponsLista.map((cupom) => (
                  <div
                    key={cupom.id}
                    style={{
                      display: "flex",
                      gap: "0.5rem",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        background: "#667eea",
                        color: "white",
                        padding: "0.4rem 0.8rem",
                        borderRadius: "4px",
                        fontSize: "0.85rem",
                      }}
                    >
                      {cupom.codigo}
                    </span>
                    {getUser()?.role === "admin" && (
                      <button
                        onClick={() => handleEditar(cupom)}
                        style={{
                          padding: "0.25rem 0.5rem",
                          fontSize: "0.8rem",
                          borderRadius: "3px",
                          border: "none",
                          background: "#d9534f",
                          color: "white",
                          cursor: "pointer",
                        }}
                      >
                        Excluir
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
